
import React from 'react';
import { Modal, Table, Button } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { getApiChara } from '../../../../util/getApi';
import { getAuthToken } from '../../../../util/auth';
import { useNavigate } from "react-router-dom";
import { FaTimes, FaSearch, FaTrash, FaCheck } from 'react-icons/fa';
import { useContext } from "react";
import AuthContext from '../../../../store/auth-context';
import { toast } from 'react-toastify';

const IPDPrescriptionSearchModal = ({ show, onClose, prescriptions, onSelect }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const authCtx = useContext(AuthContext);
    const prescriptionsArray = Object.values(prescriptions);

    const selectPrescriptionHandler = (selectedPrescription) => {
        onSelect(selectedPrescription);
        onClose();
    };

    const deletePrescriptionHandler = async (selectedPrescription) => {
        if (!window.confirm("Are you sure you want to delete this prescription?")) return;

        const preNumber = selectedPrescription[0]?.preNumber;
        const token = getAuthToken();
        const apiChar = getApiChara();
        const tenantOrClientId = authCtx.tenantOrClientId;

        try {
            const response = await fetch(`${apiChar}/savedPrescription/deleteSavedPrescriptionRecordsByPreNumber?preNumber=${preNumber}&tenantOrClientId=${tenantOrClientId}`, {
                method: 'DELETE',
                headers: { Authorization: 'Bearer ' + token }
            });
            if (!response.ok) throw new Error("Could not delete");
            onClose();
        } catch (error) {
            console.error(error);
            alert("Failed to delete prescription.");
        }
    };

    return (
        <Modal show={show} onHide={onClose} size="lg" centered scrollable>
            <Modal.Header closeButton className="modal-header-themed">
                <Modal.Title><FaSearch className="me-2" /> {t("Prescriptions")}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#f8f9fa" }}>
                {prescriptionsArray.length === 0 ? (
                    <p className="text-center py-4">{t("No prescriptions found.")}</p>
                ) : (
                    prescriptionsArray.map((prescription, index) => (
                        <div key={index} className="card mb-4 shadow-sm">
                            <div className="card-body p-0">
                                <Table responsive striped hover className="mb-0 overflow-hidden" style={{ borderRadius: "8px" }}>
                                    <thead className="bg-light">
                                        <tr>
                                            <th className="small py-2">{t("Name")}</th>
                                            <th className="small py-2">{t("Type")}</th>
                                            <th className="small py-2 text-center">{t("Dosage")}</th>
                                            <th className="small py-2 text-center">{t("B/L/D")}</th>
                                            <th className="small py-2 text-center">{t("Days")}</th>
                                            <th className="small py-2">{t("Instr")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {prescription.map((m) => (
                                            <tr key={m.id}>
                                                <td className="small">{m.medicineName}</td>
                                                <td className="small">{m.type}</td>
                                                <td className="small text-center">{m.dosage || "-"}</td>
                                                <td className="small text-center">{m.breakFastDose}/{m.lunchDose}/{m.dinnerDose}</td>
                                                <td className="small text-center">{m.days}</td>
                                                <td className="small">{m.notes || "-"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                <div className="d-flex justify-content-end gap-2 p-2 bg-light border-top">
                                    <Button className="btn-outline-danger-premium" size="sm" onClick={() => deletePrescriptionHandler(prescription)}>
                                        <FaTrash className="me-2" /> {t("Delete")}
                                    </Button>
                                    <Button className="btn-outline-premium" size="sm" onClick={() => selectPrescriptionHandler(prescription)}>
                                        <FaCheck className="me-2" /> {t("Select Prescription")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-secondary-premium" onClick={onClose}>
                    <FaTimes className="me-2" /> {t("Close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default IPDPrescriptionSearchModal;
